export default __webpack_public_path__ + "static/media/cv.356d3416.pdf";